export default "/static/build/boundly-logo-white-new.png";